(() => {
  function init(root) {
    if (root.dataset.merchReady) return;
    root.dataset.merchReady = 'true';
    let request;
    let busy = false;
    let keyboardInput = false;
    root.addEventListener('pointerdown', () => { keyboardInput = false; }, true);
    root.addEventListener('keydown', () => { keyboardInput = true; }, true);
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-merch-image]');
      if (!thumb || !root.contains(thumb)) return;
      const img = root.querySelector('[data-merch-main-image] img');
      if (!img) return;
      img.removeAttribute('srcset');
      img.src = thumb.dataset.merchImage;
      img.alt = thumb.dataset.merchAlt;
      root.querySelectorAll('[data-merch-image]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    });
    root.addEventListener('submit', event => {
      if (busy || !root.querySelector('[name="id"]').value || root.querySelector('[data-merch-add]').disabled) {
        event.preventDefault();
      } else {
        busy = true;
        root.querySelector('[data-merch-add]').setAttribute('aria-busy', 'true');
      }
    });
    root.addEventListener('change', async event => {
      if (!event.target.matches('[data-merch-option]')) return;
      if (request) request.abort();
      const controller = new AbortController();
      request = controller;
      busy = true;
      const status = root.querySelector('[data-merch-status]');
      const purchase = root.querySelector('[data-merch-purchase]');
      const position = event.target.dataset.position;
      const quantity = purchase.querySelector('[name="quantity"]').value;
      const url = new URL(window.location.href);
      url.searchParams.set('view', root.dataset.merchView || 'merch-product');
      url.searchParams.delete('variant');
      url.searchParams.set('section_id', root.dataset.sectionId);
      url.searchParams.set('option_values', [...purchase.querySelectorAll('[data-merch-option]')].map(select => select.value).join(','));
      purchase.querySelector('[data-merch-add]').disabled = true;
      purchase.setAttribute('aria-busy', 'true');
      status.textContent = status.dataset.loading;
      root.querySelector('[data-merch-fallback]').hidden = true;
      try {
        const response = await fetch(url, {signal: controller.signal, credentials: 'same-origin'});
        if (!response.ok) throw new Error('Variant response failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        let next = doc.querySelector('[data-merch-purchase]');
        if (!next || !next.querySelector('form')) throw new Error('Variant section missing');
        if (controller !== request) return;
        const restoreFocus = keyboardInput && document.activeElement === event.target;
        if (root.dataset.personal === 'true') {
          purchase.querySelector('[name="id"]').value = next.querySelector('[name="id"]').value;
          purchase.querySelector('.tdt-mp__options')?.replaceWith(next.querySelector('.tdt-mp__options'));
          purchase.querySelector('.tdt-mp__price').replaceWith(next.querySelector('.tdt-mp__price'));
          const currentQty = purchase.querySelector('[name="quantity"]');
          const nextQty = next.querySelector('[name="quantity"]');
          ['min','max','step'].forEach(name => {if(nextQty.hasAttribute(name)) currentQty.setAttribute(name,nextQty.getAttribute(name)); else currentQty.removeAttribute(name);});
          purchase.querySelector('[data-merch-add]').disabled = next.querySelector('[data-merch-add]').disabled;
          purchase.removeAttribute('aria-busy');
          next = purchase;
        } else {
          purchase.replaceWith(next);
        }
        const qty = next.querySelector('[name="quantity"]');
        const count = Number(quantity);
        if (Number.isFinite(count) && count >= Number(qty.min) && (!qty.max || count <= Number(qty.max)) && (count - Number(qty.min)) % Number(qty.step) === 0) qty.value = quantity;
        const image = doc.querySelector('[data-merch-main-image]');
        if (image) root.querySelector('[data-merch-main-image]').replaceWith(image);
        const thumbs = doc.querySelector('.tdt-mp__thumbs');
        if (thumbs && root.querySelector('.tdt-mp__thumbs')) root.querySelector('.tdt-mp__thumbs').replaceWith(thumbs);
        if (restoreFocus) next.querySelector(`[data-position="${position}"]`)?.focus({preventScroll: true});
        status.textContent = '';
        const variant = next.querySelector('[name="id"]').value;
        url.searchParams.delete('section_id');
        if (variant) {url.searchParams.set('variant', variant);url.searchParams.delete('option_values');}
        window.history.replaceState(window.history.state, '', url);
        busy = false;
      } catch (error) {
        if (error.name === 'AbortError') return;
        if (controller !== request) return;
        status.textContent = status.dataset.error;
        purchase.removeAttribute('aria-busy');
        root.querySelector('[data-merch-fallback]').hidden = false;
        busy = true;
      }
    });
    window.addEventListener('pageshow', event => {if (event.persisted) {busy = false;root.querySelector('[data-merch-add]')?.removeAttribute('aria-busy');}});
  }
  document.querySelectorAll('[data-merch-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-merch-product]').forEach(init));
})();



